module.exports = __webpack_public_path__ + "img/yu2.605f3f2d.png";